import React from "react";
import { connect } from "react-redux";
import { Box, IconButton, Typography } from "@mui/material";

import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { ReactComponent as MenuIcon } from "../../assets/images/file1.svg";
import { ReactComponent as ARMenuImg } from "../../assets/images/ar_view.svg";
import styles from "./MenuItemCardImageBottom.module.scss";

import { formatPrice } from "../../constants";
import { toggleFavorite, selectIsFavorite } from "../../redux/actions/userDataActions";

import MenuListAddSubMenuBtn from "../MenuListAddSubMenuBtn";
import NutritionBadge from './NutritionBadge';

const MenuItemCardImageBottom = ({
  image,
  name,
  price,
  currency,
  onClick,
  bgColor,
  fontColor,
  imageBgColor,
  restaurantLogo,
  hasARModel,
  onArViewClick,
  arBtnBgColor,
  arBtnIconColor,
  addToCartExist,
  cartCount,
  addBtnBgColor,
  addBtnFontColor,
  isItemAvailable = true,
  availabilityMessage = "",
  allergenList,
  allergenIds,
  menuContainerRef,
  menuAttributeList,
  attributes,
  menuItemId,
  isFavorite,
  dispatch,
}) => {

  const getAllergen = (allergenId) => {
    return (allergenList ?? []).find((a) => a._id === allergenId) ?? null;
  };

  const getAttribute = (attributeId) => {
    return (menuAttributeList ?? []).find(x => x._id === attributeId) ?? null;
  }

  return (
    <Box
      className={styles.menuCard}
      onClick={isItemAvailable ? onClick : undefined}
      sx={{
        backgroundColor: bgColor ?? "#FFFFFF",
        position: "relative",
        opacity: isItemAvailable ? 1 : 0.6,
        cursor: isItemAvailable ? "pointer" : "not-allowed",
      }}
    >
      {!isItemAvailable && (
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.55)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
            pointerEvents: "none",
            borderRadius: "inherit",
          }}
        >
          <Box
            sx={{
              backgroundColor: "rgba(0, 0, 0, 0.8)",
              color: "#fff",
              padding: "8px 16px",
              borderRadius: "8px",
              fontWeight: 600,
              fontSize: "14px",
              textAlign: "center",
            }}
          >
            {availabilityMessage}
          </Box>
        </Box>
      )}
      <Box className={styles.contentContainer}>
        <Typography
          className={styles.menuName}
          sx={{
            color: fontColor ?? "#000000",
          }}
        >
          {name}
        </Typography>

        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              dispatch(toggleFavorite(menuItemId));
            }}
            sx={{ p: 0.5 }}
          >
            {isFavorite ? (
              <FavoriteIcon sx={{ fontSize: 20, color: "#e53935" }} />
            ) : (
              <FavoriteBorderIcon sx={{ fontSize: 20, color: fontColor ?? "#000000" }} />
            )}
          </IconButton>
        </Box>

        <Typography
          className={styles.menuPrice}
          sx={{
            color: fontColor ?? "#000000",
          }}
        >
          {formatPrice(price, currency)}
        </Typography>
      </Box>

      <Box
        className={styles.imageContainer}
        sx={{
          backgroundColor: imageBgColor ?? "#F5F5F5",
          position: "relative",
        }}
      >
        {image ? (
          <img src={image} alt={name} className={styles.menuImage} />
        ) : restaurantLogo ? (
          <Box className={styles.placeholderIcon}>
            <img src={restaurantLogo} alt="Restaurant" className={styles.placeholderLogo} />
          </Box>
        ) : (
          <Box className={styles.placeholderIcon}>
            <MenuIcon width="60%" height="60%" />
          </Box>
        )}
        {hasARModel && (
          <Box
            className={styles.arBadge}
            sx={{
              backgroundColor: arBtnBgColor ?? "rgba(0, 0, 0, 0.7)",
              "& path": {
                fill: arBtnIconColor ?? "#B58C67",
              },
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation();
              if (onArViewClick) {
                onArViewClick();
              }
            }}
          >
            <ARMenuImg width={30} height={30} />
          </Box>
        )}
      </Box>

      {attributes?.length > 0 && (
        <Box className={styles["allergen-row"]} style={{ marginTop: "8px", marginBottom: "8px" }}>
          {attributes.map((item, index) => {
            const attribute = getAttribute(item._idAttribute);
            if (!attribute) return null;
            return <NutritionBadge attribute={attribute} value={item.value} />
          })}
        </Box>
      )}

      {addToCartExist && (
        <Box className={styles.cartButtonContainer}>
          {cartCount > 0 ? (
            <Box className={styles.addSubMenuBtn}>
              <MenuListAddSubMenuBtn
                theme={"theme1"}
                count={cartCount}
                onAddSubMenu={(e) => {
                  e.stopPropagation();
                  onClick();
                }}
              />
            </Box>
          ) : (
            <Box
              className={styles.addButton}
              sx={{
                backgroundColor: addBtnBgColor ?? "#b99c74",
              }}
              onClick={(e) => {
                e.stopPropagation();
                onClick();
              }}
            >
              <Typography
                className={styles.addButtonText}
                sx={{
                  color: addBtnFontColor ?? "#FFF",
                }}
              >
                ADD +
              </Typography>
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

const mapStateToProps = (state, ownProps) => ({
  allergenList: state.apiData.allergenList,
  menuAttributeList: state.apiData.menuAttributesList,
  isFavorite: selectIsFavorite(state, ownProps.menuItemId),
});

export default connect(mapStateToProps)(MenuItemCardImageBottom);
